import Axios, { AxiosError } from "axios";
import { useQuery } from "react-query";
import { baseDataKeys } from "src/query-keys";
import { Region } from "src/types";

export function useRegions() {
  async function queryFn(): Promise<Region[]> {
    const result = await Axios.get(`/planning-api/regions`);
    return result.data;
  }
  return useQuery<Region[], AxiosError<Error>>(baseDataKeys.regions, () => queryFn(), {
    staleTime: 60 * 60 * 24 * 1000,
  });
}
